import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import "../styles/EmployeeList.css";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { AppDispatch } from "../redux/store";
import { fetchEmployeeAttendanceAction } from "../redux/actions/employeeAttendanceAction";
import "../styles/Form.css";

const AttendanceList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const attendances = useSelector(
    (state: StoreState) => state.employeeAttendance,
  );
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    dispatch(fetchEmployeeAttendanceAction());
  }, [dispatch]);

  const sortedData = [...attendances].sort((a, b) => {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();
    if (dateB !== dateA) {
      return dateB - dateA;
    }
    const aTime = a.checkin ? new Date(a.checkin).getTime() : 0;
    const bTime = b.checkin ? new Date(b.checkin).getTime() : 0;
    return bTime - aTime;
  });

  const dataToShow = showAll ? sortedData : sortedData.slice(0, 7);

  const formatDuration = (mins: number) => {
    if (!mins) return "—";
    const totalMs = mins * 60 * 1000;
    const hours = Math.floor(totalMs / (1000 * 60 * 60));
    const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((totalMs % (1000 * 60)) / 1000);
    return `${hours}h ${minutes}m ${seconds}s`;
  };

  return (
    <>
      <Table className="custom-employee-table" responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>BreakHrs</th>
          </tr>
        </thead>
        <tbody>
          {dataToShow.map((att) => {
            return (
              <tr key={att.id}>
                <td>{att.date}</td>
                <td>
                  {att.checkin
                    ? new Date(att.checkin).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "—"}
                </td>
                <td>
                  {att.checkout
                    ? new Date(att.checkout).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "—"}
                </td>
                <td>{formatDuration(att.breakHrs)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {!showAll && sortedData.length > 7 && (
        <div className="d-flex justify-content-end">
          <Button
            onClick={() => setShowAll(true)}
            className="btn btn-outline-success bg-success"
          >
            View More
          </Button>
        </div>
      )}
    </>
  );
};

export default AttendanceList;
